/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable prefer-destructuring */
import React from 'react';
import { connect } from 'react-redux';
import { I18n, Translate } from 'react-redux-i18n';
import NumberFormat from 'react-number-format';
import GeneralParams from '../../app/server/generalParams';
import { updateGeneralParams } from '../../app/store/actions/generalParams';
import DropZoneComponent from '../dropzone';

class GeneralComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      message: '',
      success: '',
      pendingCartDays: 0,
      customerNotBuyingForDays: 0,
      pendingQuotationDays: 0,
      sendEmailAbandoned: false,

      pendingCartDaysImageHeader: '',
      pendingCartDaysImageBody: '',
      pendingCartDaysImageHeaderFile: [],
      pendingCartDaysImageBodyFile: [],

      customerNotBuyingForDaysImageHeader: '',
      customerNotBuyingForDaysImageBody: '',
      customerNotBuyingForDaysImageHeaderFile: [],
      customerNotBuyingForDaysImageBodyFile: [],

      pendingQuotationDaysImageHeader: '',
      pendingQuotationDaysImageBody: '',
      pendingQuotationDaysImageHeaderFile: [],
      pendingQuotationDaysImageBodyFile: [],
    };
  }

  async componentDidMount() {
    const params = await GeneralParams.getGeneralParams();
    this.setParamsUpdate(params);
  }

  setParamsUpdate = async (item) => {
    await this.setState({
      userLoggedOutSeesStock:
        item.userLoggedOutSeesStock === true
        || item.userLoggedOutSeesStock === 'true',
      userLoggedInSeesStock:
        item.userLoggedInSeesStock === true
        || item.userLoggedInSeesStock === 'true',
      pendingCartDays: Number(item.pendingCartDays) || 0,
      pendingQuotationDays: Number(item.pendingQuotationDays) || 0,
      customerNotBuyingForDays: Number(item.customerNotBuyingForDays) || 0,
      sendEmailAbandoned:
        item.sendEmailAbandoned === true || item.sendEmailAbandoned === 'true',
      couponDueDaysForNewUser:
        item.couponDueDaysForNewUser === true
        || item.couponDueDaysForNewUser === 'true',
      discountPercentageForNewUserCoupon:
        Number(item.discountPercentageForNewUserCoupon) || 0,
      minimumValueForNewUserCoupon:
        Number(item.minimumValueForNewUserCoupon) || 0,
      maximumValueForNewUserCoupon:
        Number(item.maximumValueForNewUserCoupon) || 0,
      dateInicialToGenerateCoupon:
        Number(item.dateInicialToGenerateCoupon) || 0,
      dateFinalToGenerateCoupon: Number(item.dateFinalToGenerateCoupon) || 0,

      pendingCartDaysImageHeader: item.pendingCartDaysImageHeaderUrl || '',
      pendingCartDaysImageBody: item.pendingCartDaysImageBodyUrl || '',
      customerNotBuyingForDaysImageHeader:
        item.customerNotBuyingForDaysImageHeaderUrl || '',
      customerNotBuyingForDaysImageBody:
        item.customerNotBuyingForDaysImageBodyUrl || '',
      pendingQuotationDaysImageHeader:
        item.pendingQuotationDaysImageHeaderUrl || '',
      pendingQuotationDaysImageBody:
        item.pendingQuotationDaysImageBodyUrl || '',

      pendingCartDaysImageHeaderFile: [],
      pendingCartDaysImageBodyFile: [],
      customerNotBuyingForDaysImageHeaderFile: [],
      customerNotBuyingForDaysImageBodyFile: [],
      pendingQuotationDaysImageHeaderFile: [],
      pendingQuotationDaysImageBodyFile: [],
      message: '',
    });
  };

  selectedItem = (attr, value) => {
    this.setState({ [attr]: value.target.value, message: '', success: '' });
  };

  selectCheckItem = (props) => {
    this.setState(prevState => ({ [props]: !prevState[props] }));
  };

  saveDataAutomatedFollowUp = async () => {
    const {
      pendingCartDays,
      customerNotBuyingForDays,
      pendingQuotationDays,
      sendEmailAbandoned,
      couponDueDaysForNewUser,

      pendingCartDaysImageHeader,
      pendingCartDaysImageBody,
      pendingCartDaysImageHeaderFile,
      pendingCartDaysImageBodyFile,

      customerNotBuyingForDaysImageHeader,
      customerNotBuyingForDaysImageBody,
      customerNotBuyingForDaysImageHeaderFile,
      customerNotBuyingForDaysImageBodyFile,

      pendingQuotationDaysImageHeader,
      pendingQuotationDaysImageBody,
      pendingQuotationDaysImageHeaderFile,
      pendingQuotationDaysImageBodyFile,
    } = this.state;

    const params = {
      pendingCartDays,
      customerNotBuyingForDays,
      pendingQuotationDays,
      sendEmailAbandoned,
      couponDueDaysForNewUser,
      pendingCartDaysImageHeader,
      pendingCartDaysImageBody,
      customerNotBuyingForDaysImageHeader,
      customerNotBuyingForDaysImageBody,
      pendingQuotationDaysImageHeader,
      pendingQuotationDaysImageBody,
    };

    const files = {};
    if (pendingCartDaysImageHeaderFile && pendingCartDaysImageHeaderFile[0]) {
      files.pendingCartDaysImageHeaderFile = pendingCartDaysImageHeaderFile[0];
    }
    if (pendingCartDaysImageBodyFile && pendingCartDaysImageBodyFile[0]) {
      files.pendingCartDaysImageBodyFile = pendingCartDaysImageBodyFile[0];
    }
    if (
      customerNotBuyingForDaysImageHeaderFile
      && customerNotBuyingForDaysImageHeaderFile[0]
    ) {
      files.customerNotBuyingForDaysImageHeaderFile = customerNotBuyingForDaysImageHeaderFile[0];
    }
    if (
      customerNotBuyingForDaysImageBodyFile
      && customerNotBuyingForDaysImageBodyFile[0]
    ) {
      files.customerNotBuyingForDaysImageBodyFile = customerNotBuyingForDaysImageBodyFile[0];
    }
    if (
      pendingQuotationDaysImageHeaderFile
      && pendingQuotationDaysImageHeaderFile[0]
    ) {
      files.pendingQuotationDaysImageHeaderFile = pendingQuotationDaysImageHeaderFile[0];
    }
    if (
      pendingQuotationDaysImageBodyFile
      && pendingQuotationDaysImageBodyFile[0]
    ) {
      files.pendingQuotationDaysImageBodyFile = pendingQuotationDaysImageBodyFile[0];
    }

    try {
      await this.props.updateGeneralParams(params, files);
      this.setState({ success: I18n.t('successActualized'), message: '' });
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      if (error && error.code === 1616) {
        this.setState({
          message: I18n.t('errorUpdatingGeneralParams'),
          success: '',
        });
      } else {
        this.setState({ message: I18n.t('errorOcurred'), success: '' });
      }
    }
  };

  setValue = (att, value) => {
    this.setState({ [att]: value });
  };

  handleDropZoneUpload = (file, stateKey) => {
    if (!file || !file.length) return;
    this.setState({ [`${stateKey}File`]: file, message: '', success: '' });
  };

  render() {
    const {
      message,
      success,
      pendingCartDays,
      customerNotBuyingForDays,
      pendingQuotationDays,
      sendEmailAbandoned,
      pendingCartDaysImageHeader,
      pendingCartDaysImageBody,
      pendingCartDaysImageHeaderFile = [],
      pendingCartDaysImageBodyFile = [],
      customerNotBuyingForDaysImageHeader,
      customerNotBuyingForDaysImageBody,
      customerNotBuyingForDaysImageHeaderFile = [],
      customerNotBuyingForDaysImageBodyFile = [],
      pendingQuotationDaysImageHeader,
      pendingQuotationDaysImageBody,
      pendingQuotationDaysImageHeaderFile = [],
      pendingQuotationDaysImageBodyFile = [],
    } = this.state;

    return (
      <div>
        <div className="row margin-bottom-20" style={{ marginTop: 10 }}>
          <div className="col-6">
            <div id="checkboxs">
              <h1 style={{ fontSize: '20px', fontWeight: 'bold' }}>
                {I18n.t('cartTracking')}
              </h1>

              <div>
                <div className="form-check">
                  <input
                    onClick={() => this.selectCheckItem('sendEmailAbandoned')}
                    type="checkbox"
                    className="form-check-input"
                    checked={sendEmailAbandoned}
                    id="sendEmailAbandoned"
                  />
                  <p className="permission-text">
                    {I18n.t('sendEmailAbandoned')}
                  </p>
                </div>

                <div id="pendingCartDays">
                  <p className="margin-bottom-2">
                    <Translate value="pendingCartDays" />
                  </p>
                  <p>
                    <NumberFormat
                      className="limit-input"
                      value={pendingCartDays}
                      onChange={e => this.setValue('pendingCartDays', e.target.value)
                      }
                      disabled={!sendEmailAbandoned}
                    />
                  </p>
                  <div className="row margin-bottom-20 banner-form-div justify-content-center">
                    <div className="col-6">
                      <label htmlFor="pendingCartDaysImageHeaderInput">
                        Header:
                      </label>
                      <DropZoneComponent
                        uploadedFile={file => this.handleDropZoneUpload(
                          file,
                          'pendingCartDaysImageHeader',
                        )
                        }
                        title={I18n.t('dragBanner')}
                        fileName={
                          pendingCartDaysImageHeaderFile
                          && pendingCartDaysImageHeaderFile[0]
                          && pendingCartDaysImageHeaderFile[0].name
                        }
                        loadImage={false}
                      />
                      {pendingCartDaysImageHeaderFile
                        && pendingCartDaysImageHeaderFile[0] && (
                          <img
                            src={URL.createObjectURL(
                              pendingCartDaysImageHeaderFile[0],
                            )}
                            className="img-logo-banners"
                            alt="Header"
                            style={{ maxHeight: 80, marginTop: 10 }}
                          />
                      )}
                      {(!pendingCartDaysImageHeaderFile
                        || !pendingCartDaysImageHeaderFile.length)
                        && pendingCartDaysImageHeader && (
                          <img
                            src={pendingCartDaysImageHeader}
                            className="img-logo-banners"
                            alt="Header"
                            style={{ maxHeight: 80, marginTop: 10 }}
                          />
                      )}
                    </div>
                    <div className="col-6">
                      <label htmlFor="pendingCartDaysImageBodyInput">
                        Body:
                      </label>
                      <DropZoneComponent
                        uploadedFile={file => this.handleDropZoneUpload(
                          file,
                          'pendingCartDaysImageBody',
                        )
                        }
                        title={I18n.t('dragBanner')}
                        fileName={
                          pendingCartDaysImageBodyFile
                          && pendingCartDaysImageBodyFile[0]
                          && pendingCartDaysImageBodyFile[0].name
                        }
                        loadImage={false}
                      />
                      {pendingCartDaysImageBodyFile
                        && pendingCartDaysImageBodyFile[0] && (
                          <img
                            src={URL.createObjectURL(
                              pendingCartDaysImageBodyFile[0],
                            )}
                            className="img-logo-banners"
                            alt="Body"
                            style={{ maxHeight: 80, marginTop: 10 }}
                          />
                      )}
                      {(!pendingCartDaysImageBodyFile
                        || !pendingCartDaysImageBodyFile.length)
                        && pendingCartDaysImageBody && (
                          <img
                            src={pendingCartDaysImageBody}
                            className="img-logo-banners"
                            alt="Body"
                            style={{ maxHeight: 80, marginTop: 10 }}
                          />
                      )}
                    </div>
                  </div>
                </div>

                <div id="pendingQuotationDays">
                  <p className="margin-bottom-2">
                    <Translate value="pendingQuotationDays" />
                  </p>
                  <p>
                    <NumberFormat
                      className="limit-input"
                      value={pendingQuotationDays}
                      onChange={e => this.setValue('pendingQuotationDays', e.target.value)
                      }
                      disabled={!sendEmailAbandoned}
                    />
                  </p>
                  <div className="row margin-bottom-20 banner-form-div justify-content-center">
                    <div className="col-6">
                      <label htmlFor="pendingQuotationDaysImageHeaderInput">
                        Header:
                      </label>
                      <DropZoneComponent
                        uploadedFile={file => this.handleDropZoneUpload(
                          file,
                          'pendingQuotationDaysImageHeader',
                        )
                        }
                        title={I18n.t('dragBanner')}
                        fileName={
                          pendingQuotationDaysImageHeaderFile
                          && pendingQuotationDaysImageHeaderFile[0]
                          && pendingQuotationDaysImageHeaderFile[0].name
                        }
                        loadImage={false}
                      />
                      {pendingQuotationDaysImageHeaderFile
                        && pendingQuotationDaysImageHeaderFile[0] && (
                          <img
                            src={URL.createObjectURL(
                              pendingQuotationDaysImageHeaderFile[0],
                            )}
                            className="img-logo-banners"
                            alt="Header"
                            style={{ maxHeight: 80, marginTop: 10 }}
                          />
                      )}
                      {(!pendingQuotationDaysImageHeaderFile
                        || !pendingQuotationDaysImageHeaderFile.length)
                        && pendingQuotationDaysImageHeader && (
                          <img
                            src={pendingQuotationDaysImageHeader}
                            className="img-logo-banners"
                            alt="Header"
                            style={{ maxHeight: 80, marginTop: 10 }}
                          />
                      )}
                    </div>
                    <div className="col-6">
                      <label htmlFor="pendingQuotationDaysImageBodyInput">
                        Body:
                      </label>
                      <DropZoneComponent
                        uploadedFile={file => this.handleDropZoneUpload(
                          file,
                          'pendingQuotationDaysImageBody',
                        )
                        }
                        title={I18n.t('dragBanner')}
                        fileName={
                          pendingQuotationDaysImageBodyFile
                          && pendingQuotationDaysImageBodyFile[0]
                          && pendingQuotationDaysImageBodyFile[0].name
                        }
                        loadImage={false}
                      />
                      {pendingQuotationDaysImageBodyFile
                        && pendingQuotationDaysImageBodyFile[0] && (
                          <img
                            src={URL.createObjectURL(
                              pendingQuotationDaysImageBodyFile[0],
                            )}
                            className="img-logo-banners"
                            alt="Body"
                            style={{ maxHeight: 80, marginTop: 10 }}
                          />
                      )}
                      {(!pendingQuotationDaysImageBodyFile
                        || !pendingQuotationDaysImageBodyFile.length)
                        && pendingQuotationDaysImageBody && (
                          <img
                            src={pendingQuotationDaysImageBody}
                            className="img-logo-banners"
                            alt="Body"
                            style={{ maxHeight: 80, marginTop: 10 }}
                          />
                      )}
                    </div>
                  </div>
                </div>

                <div id="customerNotBuyingForDays">
                  <p className="margin-bottom-2">
                    <Translate value="customerNotBuyingForDays" />
                  </p>
                  <p>
                    <NumberFormat
                      className="limit-input"
                      value={customerNotBuyingForDays}
                      onChange={e => this.setValue(
                        'customerNotBuyingForDays',
                        e.target.value,
                      )
                      }
                      disabled={!sendEmailAbandoned}
                    />
                  </p>
                  <div className="row margin-bottom-20 banner-form-div justify-content-center">
                    <div className="col-6">
                      <label htmlFor="customerNotBuyingForDaysImageHeaderInput">
                        Header:
                      </label>
                      <DropZoneComponent
                        uploadedFile={file => this.handleDropZoneUpload(
                          file,
                          'customerNotBuyingForDaysImageHeader',
                        )
                        }
                        title={I18n.t('dragBanner')}
                        fileName={
                          customerNotBuyingForDaysImageHeaderFile
                          && customerNotBuyingForDaysImageHeaderFile[0]
                          && customerNotBuyingForDaysImageHeaderFile[0].name
                        }
                        loadImage={false}
                      />
                      {customerNotBuyingForDaysImageHeaderFile
                        && customerNotBuyingForDaysImageHeaderFile[0] && (
                          <img
                            src={URL.createObjectURL(
                              customerNotBuyingForDaysImageHeaderFile[0],
                            )}
                            className="img-logo-banners"
                            alt="Header"
                            style={{ maxHeight: 80, marginTop: 10 }}
                          />
                      )}
                      {(!customerNotBuyingForDaysImageHeaderFile
                        || !customerNotBuyingForDaysImageHeaderFile.length)
                        && customerNotBuyingForDaysImageHeader && (
                          <img
                            src={customerNotBuyingForDaysImageHeader}
                            className="img-logo-banners"
                            alt="Header"
                            style={{ maxHeight: 80, marginTop: 10 }}
                          />
                      )}
                    </div>
                    <div className="col-6">
                      <label htmlFor="customerNotBuyingForDaysImageBodyInput">
                        Body:
                      </label>
                      <DropZoneComponent
                        uploadedFile={file => this.handleDropZoneUpload(
                          file,
                          'customerNotBuyingForDaysImageBody',
                        )
                        }
                        title={I18n.t('dragBanner')}
                        fileName={
                          customerNotBuyingForDaysImageBodyFile
                          && customerNotBuyingForDaysImageBodyFile[0]
                          && customerNotBuyingForDaysImageBodyFile[0].name
                        }
                        loadImage={false}
                      />
                      {customerNotBuyingForDaysImageBodyFile
                        && customerNotBuyingForDaysImageBodyFile[0] && (
                          <img
                            src={URL.createObjectURL(
                              customerNotBuyingForDaysImageBodyFile[0],
                            )}
                            className="img-logo-banners"
                            alt="Body"
                            style={{ maxHeight: 80, marginTop: 10 }}
                          />
                      )}
                      {(!customerNotBuyingForDaysImageBodyFile
                        || !customerNotBuyingForDaysImageBodyFile.length)
                        && customerNotBuyingForDaysImageBody && (
                          <img
                            src={customerNotBuyingForDaysImageBody}
                            className="img-logo-banners"
                            alt="Body"
                            style={{ maxHeight: 80, marginTop: 10 }}
                          />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button
          onClick={() => this.saveDataAutomatedFollowUp()}
          type="button"
          className="btn btn-secondary margin-bottom-20"
        >
          <Translate value="save" />
        </button>

        {success && <p className="color-green margin-top-10">{success}</p>}
        {message && <p className="color-red margin-top-10">{message}</p>}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  settings: state.settings,
});

const mapDispatchToProps = dispatch => ({
  updateGeneralParams: (params, files) => dispatch(updateGeneralParams(params, files)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GeneralComponent);
